import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IDocument } from 'app/models/documents/document';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import { IDocumentType } from 'app/models/documents/documentType';
import { IServiceCenterLicense } from 'app/models/licenses/service-center-license';
import { ITrainingProgram } from 'app/models/training/training-program';
import { IWorkerLicense } from 'app/models/licenses/worker-license';
import { IPracticumSiteOregon } from 'app/models/training/practicum-site-oregon';
import { IOutOfStatePracticumSite } from 'app/models/training/out-of-state-practicum-site';

@Injectable(
  { providedIn: 'root' }
)

export class ServiceCenterService {
  private api: string = environment.privateApi + 'ServiceCenter/';

  constructor(private http: HttpClient) { }

  getLicenses(): Observable<IServiceCenterLicense[]> {
    return this.http.get<IServiceCenterLicense[]>(this.api + 'GetLicenses');
  }

  createLicense(): Observable<IServiceCenterLicense> {
    return this.http.post<IServiceCenterLicense>(this.api + 'CreateLicense', null);
  }

  updateLicense(license: IServiceCenterLicense) {
    this.http.post<boolean>(this.api + 'UpdateLicense', license).subscribe(
      error => console.log('error', error)
    );
  }

  requestWithdraw(id: number): Observable<IServiceCenterLicense> {
    return this.http.post<IServiceCenterLicense>(this.api + "requestWithdraw/" + id, null);
  }

  requestSurrender(id: number): Observable<IServiceCenterLicense> {
    return this.http.post<IServiceCenterLicense>(this.api + "requestSurrender/" + id, null);
  }

  getDocumentTypes(): Observable<IDocumentType[]> {
    return this.http.get<IDocumentType[]>(this.api + 'GetDocumentTypes');
  }

  uploadDocument(files: FormData): Observable<IDocument> {
    return this.http.post<IDocument>(this.api + 'UploadDocument', files)
  }

  downloadFile(fileId: number): Observable<Blob> {
    return this.http.get<Blob>(this.api + "DownloadDocument/" + fileId, { responseType: 'blob' as 'json' })
  }

  deleteDocument(id: number): Observable<any> {
    return this.http.delete<any>(this.api + "DeleteDocument/" + id)
  }

  submitApplication(license: IServiceCenterLicense, renewal: boolean): Observable<IServiceCenterLicense> {
    return this.http.post<IServiceCenterLicense>(this.api + "SubmitLicense/" + renewal, license);
  }

  withdrawApplication(license: IServiceCenterLicense): Observable<IServiceCenterLicense> {
    return this.http.post<IServiceCenterLicense>(this.api + "WithdrawLicense", license);
  }

  reopenApplication(license: IServiceCenterLicense): Observable<IServiceCenterLicense> {
    return this.http.post<IServiceCenterLicense>(this.api + "reopenLicense", license);
  }

  createRenewalLicense(licenseId: number): Observable<IServiceCenterLicense> {
    return this.http.post<IServiceCenterLicense>(this.api + 'CreateServiceCenterRenewal/' + licenseId, null);
  }

  //Practicum Sites
  getTrainingPrograms(): Observable<ITrainingProgram[]> {
    return this.http.get<ITrainingProgram[]>(this.api + 'GetTrainingPrograms');
  }

  updateTrainingProgram(licenseId: number, practicumSite: IPracticumSiteOregon): Observable<IPracticumSiteOregon> {
    return this.http.post<IPracticumSiteOregon>(this.api + 'UpdateTrainingProgram/' + licenseId, practicumSite);
  }

  updateTrainingProgramOutOfState(licenseId: number, practicumSite: IOutOfStatePracticumSite): Observable<IOutOfStatePracticumSite> {
    return this.http.post<IOutOfStatePracticumSite>(this.api + 'UpdateTrainingProgramOutOfState/' + licenseId, practicumSite);
  }

  deleteTrainingProgram(licenseId: number, id: number): Observable<boolean> {
    return this.http.delete<boolean>(this.api + 'DeleteTrainingProgram/' + licenseId + '/' + id);
  }

  deleteTrainingProgramOutOfState(licenseId: number, id: number): Observable<boolean> {
    return this.http.delete<boolean>(this.api + 'DeleteTrainingProgramOutOfState/' + licenseId + '/' + id);
  }

  archiveTrainingProgram(licenseId: number, id: number): Observable<boolean> {
    return this.http.post<boolean>(this.api + 'ArchiveTrainingProgram/' + licenseId + '/' + id, null);
  }

  archiveTrainingProgramOutOfState(licenseId: number, id: number): Observable<boolean> {
    return this.http.post<boolean>(this.api + 'ArchiveTrainingProgramOutOfState/' + licenseId + '/' + id, null);
  }

  addWorkerPermit(licenseId: number, permitIds: string[]): Observable<IWorkerLicense[]> {
    return this.http.post<IWorkerLicense[]>(this.api + 'AddWorkerPermit/' + licenseId, permitIds);
  }

  addSB303WorkerPermit(licenseId: number, permitIds: string[]): Observable<IWorkerLicense[]> {
    return this.http.post<IWorkerLicense[]>(this.api + 'AddSB303WorkerPermit/' + licenseId, permitIds);
  }

  removeWorkerPermit(licenseId: number, permitId: string): Observable<boolean> {
    return this.http.delete<boolean>(this.api + 'RemoveWorkerPermit/' + licenseId + '/' + permitId);
  }

  removeSB303WorkerPermit(licenseId: number, permitId: string): Observable<boolean> {
    return this.http.delete<boolean>(this.api + 'RemoveSB303WorkerPermit/' + licenseId + '/' + permitId);
  }
}
